import { DirectusImageGalleryBlock } from 'config';
import { ImageGalleryBlockProps } from '../../../components/blocks';
import { mapDirectusImage } from '../general';

export const mapDirectusImageGalleryBlock = ({ image }: DirectusImageGalleryBlock): ImageGalleryBlockProps => {
  return {
    image: image?.map((item: any) => ({
      image: mapDirectusImage(item?.single_image_block_id?.image),
      image_description: item?.single_image_block_id?.image_description,
    })),
  };
};
